<div class="navbar-wrapper position-relative z-index">
  <nav class="navbar navbar-light bg-white navbar-sobreposto header-div">
    <div class="navbar-brand" routerLink="/home">
      <div style="display: flex;">
        <img src="/assets/img/logo-novo.png" style="margin-right: 20px;height: 52px;width: 78px" alt="logo alelo"
             height="104" width="156">
        <img src="/assets/img/logo-texto.png" style="height: 37px;width: 143px" alt="logo alelo" height="60"
             width="235">
      </div>
    </div>
    <div class="navbar-text p-0 pe-lg-5 mt-3 mt-md-0">
      <div class="align-items-center" style="display: flex;margin-right: -15px;margin-left: -15px">
        <div style="margin-right: 15px">
          <p class="bem-vindo">
            Bem vindo, {{username | camelCase}}
          </p>
        </div>
        <div class="navbar-sobreposto">
          <span class="dropdown dropdown-perfil text-nowrap">
            <div class="div-icone-perfil">
              <img src="/assets/img/icone-perfil.png" alt="logo alelo">
              <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
            </div>
            <div class="container-dropdown-perfil">
               <div class="triangulo-perfil"></div>
              <div class="div-dropdown">
              <p class="itens-dropdown text-nowrap" (click)="privacidadeESeguranca()" (keydown.enter)="privacidadeESeguranca()">Políticas de Privacidade</p>
              </div>
              <hr class="hr" style="margin-top: 5px;margin-bottom: 1px;">
              <div class="div-dropdown">
              <p class="itens-dropdown" (click)="sairDoSistema()" (keydown.enter)="sairDoSistema()">
              <i class="fa fa-sign-out" aria-hidden="true" style="margin-right: 5px"></i>Sair do sistema</p>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </nav>
</div>
